export enum ERoles {
  ADMIN = 'uzu-admin',
  VIEW_HOUSING = 'view-housing',
  VIEW_LAND = 'view-land',
  CITIZEN_INFORMATION_REQUEST_EMPLOYEE = 'citizen-information-request-employee',
}
